<template>
  <div>
    <div class="copyright-search-wrap table-search-top search-bar-bg">
      <input
        v-model="keyword"
        class="copyright-search"
        type="search"
        placeholder="アーティスト検索">
    </div>
    <div
      v-if="searchStatus === 1"
      class="artist-list">
      <p class="artist-not-exist">
        このキーワードのアーティストは登録されていません。
      </p>
    </div>
    <div
      v-if="searchStatus === 0 || vocaloids.length === 0"
      class="artist-list">
      <p class="artist-not-exist">
        アーティストが登録されていません。
      </p>
    </div>
    <div
      ref="scrollComponent"
      :class="{'infinite-scroll-container': vocaloids.length > 0}"
      :style="vocaloids.length > 9 ? { height: '400px' } : { height: 'fit-content' }">
      <div
        v-if="vocaloids.length > 0"
        class="c-artist-list">
        <a
          v-for="item in vocaloids"
          :key="item.id"
          :class="{ 'overlay disabled' : item.options.overlay }"
          class="scrollable-artist-list"
          href="#"
          @click.prevent="onSelectArtist(item)">
          <p class="scrollable-artist-overlay-text">{{ item.options.overlayText }}</p>
          <div
            :style="`background-image: url(/images/${item.image_path})`"
            class="pic">
          </div>
          <span class="artist-list__name_text scrollable-artist-list-name">
            {{ item.name_ja }}
          </span>
        </a>
      </div>
    </div>
  </div>
</template>
<script>

export default {
  name: 'SearchableVocaloidList',
  props: {
    vocaloids: {
      type: Array,
      default: () => [],
    },
    lastPage: {
      type: Boolean,
      required: true,
    },
    belongsTo: {
      type: String,
      default: '',
    },
    searchStatus: {
      type: Number,
      required: true,
    },
  },
  data() {
    return {
      keyword: '',
      page: 1,
    }
  },
  watch: {
    keyword(newSearchValue) {
      this.$emit('search', {
        keyword: newSearchValue,
        belongsTo: this.belongsTo,
      })
    },
  },
  mounted() {
    if (this.page === 1) {
      this.$emit('handle', this.belongsTo)
    }
    const element = this.$refs.scrollComponent
    element.addEventListener('scroll', this.handleScroll)
  },
  beforeUnmount() {
    const element = this.$refs.scrollComponent
    element.removeEventListener('scroll', this.handleScroll)
  },
  methods: {
    search() {
      this.$emit('search', {
        keyword: this.keyword,
        belongsTo: this.belongsTo,
      })
    },
    onSelectArtist(data) {
      this.$emit('notify', {
        data,
        belongsTo: this.belongsTo,
      })
    },
    handleScroll() {
      const element = this.$refs.scrollComponent
      const sH = element.scrollHeight
      if ((sH) === (element.scrollTop + 398) && this.lastPage === false) {
        this.page += 1
        this.$emit('pagination', {
          page: this.page,
          belongsTo: this.belongsTo,
        })
      }
    },
  },
}
</script>
<style scoped>
.search-bar-bg {
  background: white;
}
</style>
